module.exports = __webpack_public_path__ + "static/media/logo.dc20e709.png";